var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M12.6123 0.734375C13.3014 0.734375 13.9412 1.12812 14.2857 1.71875L24.917 19.8313C25.2615 20.4711 25.2615 21.2094 24.917 21.8C24.5725 22.4398 23.9326 22.7844 23.2436 22.7844H1.98105C1.24277 22.7844 0.60293 22.4398 0.258398 21.8C-0.0861328 21.2094 -0.0861328 20.4711 0.258398 19.8313L10.8896 1.71875C11.2342 1.12812 11.874 0.734375 12.6123 0.734375ZM12.6123 7.03438C11.9232 7.03438 11.4311 7.57578 11.4311 8.21563V13.7281C11.4311 14.4172 11.9232 14.9094 12.6123 14.9094C13.2521 14.9094 13.7936 14.4172 13.7936 13.7281V8.21563C13.7936 7.57578 13.2521 7.03438 12.6123 7.03438ZM14.1873 18.0594C14.1873 17.2227 13.449 16.4844 12.6123 16.4844C11.7264 16.4844 11.0373 17.2227 11.0373 18.0594C11.0373 18.9453 11.7264 19.6344 12.6123 19.6344C13.449 19.6344 14.1873 18.9453 14.1873 18.0594Z",
    fill: "#F56720"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a3e117e09e188d8a70feb5afec9d5b66.svg";
export { ForwardRef as ReactComponent };